import pkgJson from '../../../../package.json';

export const environment = {
  production: false,
  name: 'LOCAL',
  app_version: pkgJson.version,

  app_install_prompt: 3, // in days, next request for user to install app

  auth0_domain: 'smarthead-test.eu.auth0.com',
  auth0_clientId: 'eG5e3Y7GiwOxyD0RyXYDhEoQu6Z13j80',
  auth0_connection: 'Username-Password-Authentication',
  auth0_custom_claims_prefix: 'https://dev2.besmarthead.com/',
  auth0_token_expiration: 2592000,

  api_smarthead_base_path: 'https://api-v3-dev2.besmarthead.com',
  // api_smarthead_base_path: 'http://localhost:8000',
  api_smarthead_v2_base_path: 'https://api-v2-dev2.besmarthead.com',
  api_auth0: 'https://smarthead-test.eu.auth0.com',
  api_link_shortener_base_path: 'https://sh-dev2.besmarthead.com',

  client_statistics_enabled: false,

  // aws s3 configuration - file storage
  file_storage: 'https://files-test.besmarthead.com',
  // file_storage: 'https://besmarthead-local.s3-eu-west-1.amazonaws.com',

  // link shortener domain
  linkShortenerDomain: 'https://sh-dev2.besmarthead.com',
  linkShortenerRedirectUrlDomain: 'https://dev2.besmarthead.com',

  // upload file + other data to upload
  maxUploadFileSize: 20_971_520, // 20MB
  maxUploadImageWidthResolution: 8_500,
  maxUploadImageHeightResolution: 8_500,
  maxTextareaLength: 50_000,
  imageTargetResolution: 2_000,

  // translation
  disabledLanguages: [],
  defaultLanguage: 'EN',
  adminDefaultLanguage: 'en', // should be 'TranslationLanguage' - in lowercase
  adminSupportedLanguage: [
    'en',
    'gb',
    'sk',
    'cs'
  ], // should be item from 'TranslationLanguage' - in lowercase

  // embedly
  embedly_code: '85aa04d65acc44f3830fe971b3a37dd4',

  // google api
  google_api_key: 'AIzaSyA5EA-zHdghBR00WJN700Nro4qhrznQDIA',
  google_default_zoom_level: 7,
  google_recapatcha: '6Ld7N-wUAAAAAFANQ9RwIp_ZgYypq9UkINr1sMty',

  // google analytics
  initGoogleTagManager: false,
  googleAnalyticsTrackingID: null,
  googleTagManagerID: null,

  // chargebee
  chargebeeSite: 'besmarthead-test',
  tax: 20,

  // fb
  fbAPIKey: '1802924673092497',

  // cookie, cookie law
  cookies_secure: false,

  // sentry.io
  sentryDSN: null,

  // ELK APM,
  elkAPM: null,
  elkAPMDistributedTracingOrigins: [],

  // froala licence
  froalaKey: '3AC6eD4A5F4E3B3I3C-22cgpidtsj1lkoF6nablA3C11A8B6D2C4F4G2C3I3==',

  // butter cms
  butterCmsKey: '0052d4ee360c18fca186fb46213b177ee5c4ddc9',

  analytics: {
    profilesWithMockedData: [46142]
  },

  // pdf reports
  report: {
    market: {
      allowedIndustry: ['ACCOUNTING'],
      allowedCompanySize: ['EMPLOYEES_11_50']
    }
  },
  cookieDomain: 'dev2.besmarthead.com',
  pdfDomainPrefix: 'https://dev2.besmarthead.com',

  maxPagesAnonymousUserCanSee: 3,

  mediaTagsToExclude: [
    'sk',
    'gb',
    'cs',
    'de',
    'premium'
  ],

  pipeDriveDemoLink: 'https://smarthead.pipedrive.com/scheduler/6BzLBrC2/video-call-with-jan-dudas',

  // hot jar
  hotjarActive: false,
  hotjarId: '2664460',

  // activities to load on home/business page
  businessPageActivities: [
    47490,
    47379,
    47300,
    47483,
    47327,
    47328,
    47471,
    47326,
    47299,
    47470,
    46951,
    47334
  ],

  // explore static pages domain
  exploreDomain: 'https://explore.besmarthead.com',
  exploreDomainSuffix: '/localhost'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
